import { useTranslation } from 'react-i18next';

export const MarketDrivenShippingMigrateConfirmModalContent: React.FC = () => {
    const { t } = useTranslation();

    return <s-text>{t('MARKET_DRIVEN_SHIPPING_MIGRATED_BANNER.CONFIRM_MODAL.DESCRIPTION')}</s-text>;
};

export default MarketDrivenShippingMigrateConfirmModalContent;
